import { withProps } from 'recompose'

import Testimonial from 'layouts/Testimonial'

import nameIconSrcDark from './leo-strupczewski-dark.svg'
import nameIconSrcLight from './leo-strupczewski-light.svg'
import faceIconSrc from './leo-face.png'

export default withProps(props => {
  return {
    role: 'Director of Marketing',
    nameIconSrc: props.meetings ? nameIconSrcLight : nameIconSrcDark,
    faceIconSrc,
    quote: `
      Drift helps us solve our biggest challenge: Connecting with Sales-ready leads more quickly. Big bonus: It’s nearly fully automated and requires little day-to-day oversight.
    `,
    company: 'TreeRing',
}})(Testimonial)
